import { utf8Encode } from "./utils";

export const CRYPTO_KID = "v1";
export const HKDF_INFO = utf8Encode("bettimax/aead/v1");

export function getServerPubFingerprint(): string {
  return (import.meta as any).env?.VITE_CRYPTO_SERVER_PUB_FINGERPRINT || "";
}

export function getHandshakePathname(): string {
  return "/bettimax/handshake";
}
